import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import Api from "../../services/api";
import withRouter from "../../services/withRouter";
import { GoogleLoginButton } from "react-social-login-buttons";

import Modal from 'react-bootstrap/Modal';

import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin, googleLogout } from '@react-oauth/google';

const Login = ({showDisclaimer}) => {

	const [show_login_popup, setLoginPopup] = useState(false);
	const [user, setUser] = useState({});
	const [show_dropdown, setDropdown] = useState(false);

	useEffect(() => {
		getUserInfo();

		const handleClickOutside = (event) => {
			if (!event.target.closest('.user-profile-chip') && !event.target.closest('.user-dropdown-menu')) {
				setDropdown(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);


	const getUserInfo = async()=>{
		var user = await localStorage.getItem('user') || "";
		if(user){
			setUser(JSON.parse(user))
			showDisclaimer()
		}
		else{
			setLoginPopup(true)
		}
	}


	const login = useGoogleLogin({
		onSuccess: (response) => {
		  googleLogin(response)
		},
		onError: (error) => {
		  // Handle login errors
		  console.error('Login error:', error);
		}
	});


	const googleLogin = async(token_response)=>{
		var response = await Api.GetUserInfo(token_response.access_token)
		var data = {
			"email" : response.email,
			"name" : response.name,
			"profile_pic" : response.picture,
			"client_id" : response.id
		}
		localStorage.setItem('user', JSON.stringify(data));
		setUser(data)
		var response = await Api.PostRequest(data, "user");
		setLoginPopup(false);
		showDisclaimer();
	}

	const handleLogout = () => {
		localStorage.removeItem('user');
		setUser({});
		setDropdown(false);
		setLoginPopup(true);
	};

	const handleSwitchAccount = () => {
		setDropdown(false);
		login();
	};

    return (
        <>
			<Modal show={show_login_popup} backdrop="static" keyboard={false} centered>
                <Modal.Body>
					<div className="justify-content-center d-flex align-items-center flex-column py-5" style={{'backgroundImage' : "url(" + "/assets/img/popup.png" + ")", 'backgroundPosition': 'center', 'backgroundSize': 'cover', 'backgroundRepeat': 'no-repeat'}}>
                        <img src="/assets/img/logo.png" alt="logo" style={{'width' : '100px'}}/>
                        <div className="d-flex flex-column justify-content-center align-items-center mt-2">
                            <h2 style={{'color' : '#1d5a9f', 'fontWeight' : 'bold'}}>SAHYOG SETU PORTAL</h2>

							<h4 className="mt-4 py-2 px-3" style={{'color' : 'var(--white-color)', background:'#212530', 'fontWeight' : 'bold', 'borderRadius' : '50px'}}>POWERED BY</h4>
                            <span className="mt-4 py-4 px-5" style={{'color' : '#212530', background:'#FFFFFF',  fontSize : '18px', 'fontWeight' : 'bold', 'textAlign' : 'center', 'borderRadius' : '100%', border:'1px solid #dadce0'}}>Uplift Live Foundation</span>
                        </div>
						<div className="mt-5">
							<GoogleLoginButton onClick={() => { login()}}></GoogleLoginButton>
						</div>
                    </div>
                </Modal.Body>
			</Modal>

			{Object.keys(user).length > 0 &&
				<div className="position-relative">
					<div onClick={() => setDropdown(!show_dropdown)} className="user-profile-chip d-flex align-items-center py-1 px-2" style={{ cursor: 'pointer' }}>
						<img src={user.profile_pic} alt="user avatar" className="user-avatar shadow-sm" />
						<span className="user-name-text d-none d-md-inline mx-2">{user.name}</span>
						<i className="fa fa-chevron-down ms-1 d-none d-md-inline" style={{ fontSize: '10px', color: '#666' }}></i>
					</div>
					
					{show_dropdown && (
						<div className="user-dropdown-menu shadow position-absolute bg-white py-3 px-3 rounded mt-2" style={{ right: 0, zIndex: 10000, minWidth: '240px' }}>
							<div className="d-flex align-items-center flex-column border-bottom pb-3 mb-2">
								<img src={user.profile_pic} alt="user avatar large" className="user-avatar-large mb-2 shadow-sm" />
								<div className="user-dropdown-name text-center w-100 text-truncate">{user.name}</div>
								<div className="user-dropdown-email text-center text-muted w-100 text-truncate" title={user.email}>{user.email}</div>
							</div>
							<button onClick={handleSwitchAccount} className="dropdown-item d-flex align-items-center py-2 px-3 rounded my-1">
								<i className="fa fa-refresh me-2 text-primary"></i> Switch Account
							</button>
							<button onClick={handleLogout} className="dropdown-item d-flex align-items-center py-2 px-3 rounded my-1 text-danger">
								<i className="fa fa-sign-out me-2"></i> Logout
							</button>
						</div>
					)}
				</div>
			}	
            
        </>
    );
}


export default withRouter(Login);
